(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hunz-consult-phases"] && !Shopify.designMode) return;
  try {
    
  (function () {
    "use strict";
    function dkReduce() { return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches; }
    function dkReveal(root) {
      var els = Array.prototype.slice.call(root.querySelectorAll("[data-dk-reveal]"));
      if (root.getAttribute("data-anim") === "none" || !("IntersectionObserver" in window) || dkReduce()) {
        els.forEach(function (el) { el.classList.add("is-in"); });
        return null;
      }
      root.classList.add("dk-anim");
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); }
        });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.05 });
      els.forEach(function (el) { io.observe(el); });
      return io;
    }
    function dkMobile() { return window.matchMedia("(max-width: 749px)").matches; }
    // Videos carry their source in data-src / data-src-m and only load when first needed
    function dkLoadVideo(v) {
      if (v.__dkLoaded) return;
      var src = dkMobile() && v.getAttribute("data-src-m") ? v.getAttribute("data-src-m") : v.getAttribute("data-src");
      if (!src) return;
      v.src = src; v.__dkLoaded = true;
      v.addEventListener("playing", function () { v.classList.add("is-playing"); });
    }
    function dkPlay(v) { dkLoadVideo(v); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    // Play while on screen, pause when off screen
    function dkAutoVideos(root, selector) {
      var vids = Array.prototype.slice.call(root.querySelectorAll(selector));
      if (!vids.length) return null;
      if (!("IntersectionObserver" in window)) { vids.forEach(dkPlay); return null; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) dkPlay(en.target);
          else if (!en.target.paused) en.target.pause();
        });
      }, { threshold: 0.2 });
      vids.forEach(function (v) { io.observe(v); });
      return io;
    }
    // Media drifts slower than the page. strength 0.12 = moves 12% of the screen height across the whole pass.
    function dkParallax(section, layer, strength) {
      if (!layer || dkReduce()) return null;
      var ticking = false;
      var update = function () {
        ticking = false;
        var r = section.getBoundingClientRect(), vh = window.innerHeight;
        if (r.bottom < -50 || r.top > vh + 50) return;
        var offset = (r.top + r.height / 2 - vh / 2) * -strength;
        layer.style.transform = "translate3d(0," + offset.toFixed(1) + "px,0)";
      };
      var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
      document.addEventListener("scroll", onScroll, { capture: true, passive: true });
      window.addEventListener("resize", onScroll);
      update();
      return function () {
        document.removeEventListener("scroll", onScroll, { capture: true });
        window.removeEventListener("resize", onScroll);
      };
    }
    // Clicks on any [data-dkx-track] are reported to Shopify (customer events) and Google Tag Manager, for A/B testing
    function dkxTrack(root) {
      root.addEventListener("click", function (e) {
        var a = e.target.closest ? e.target.closest("[data-dkx-track]") : null;
        if (!a) return;
        var d = { location: a.getAttribute("data-dkx-track"), label: (a.textContent || "").replace(/\s+/g, " ").trim().slice(0, 80) };
        try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish("dk_cta_click", d); } catch (err) {}
        try { (window.dataLayer = window.dataLayer || []).push({ event: "dk_cta_click", dk_location: d.location, dk_label: d.label }); } catch (err) {}
      });
    }
    // On-page links (#book) glide there, also when the theme scrolls inside a wrapper
    function dkxAnchors(root) {
      root.addEventListener("click", function (e) {
        var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
        if (!a) return;
        var id = a.getAttribute("href").slice(1);
        var t = id && document.getElementById(id);
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: dkReduce() ? "auto" : "smooth", block: "start" });
        if (history.replaceState) history.replaceState(null, "", "#" + id);
      });
    }
    // Per-video speed: 0.5 = slow cinematic, 2 = fast
    function dkxRates(root) {
      Array.prototype.forEach.call(root.querySelectorAll("video[data-rate]"), function (v) {
        var r = parseFloat(v.getAttribute("data-rate")) || 1;
        if (r === 1) return;
        var set = function () { try { v.defaultPlaybackRate = r; v.playbackRate = r; } catch (err) {} };
        v.addEventListener("loadedmetadata", set); v.addEventListener("play", set); set();
      });
    }

    function Phases(root) {
      var self = this;
      this.root = root;
      this.tabs = Array.prototype.slice.call(root.querySelectorAll("[data-dkxt-tab]"));
      this.panels = Array.prototype.slice.call(root.querySelectorAll("[data-dkxt-panel]"));
      this.media = Array.prototype.slice.call(root.querySelectorAll("[data-dkxt-media]"));
      this.index = 0;
      this.seconds = parseInt(root.getAttribute("data-autoplay"), 10) || 0;
      this.visible = false;
      dkxRates(root);
      this.io = dkReveal(root);
      dkxTrack(root); dkxAnchors(root);

      this.tabs.forEach(function (t, i) {
        t.addEventListener("click", function () { self.stopAuto(); self.go(i, true); });
        t.addEventListener("keydown", function (e) {
          var k = e.key, n = self.tabs.length, j = -1;
          if (k === "ArrowRight" || k === "ArrowDown") j = (i + 1) % n;
          if (k === "ArrowLeft" || k === "ArrowUp") j = (i - 1 + n) % n;
          if (k === "Home") j = 0;
          if (k === "End") j = n - 1;
          if (j > -1) { e.preventDefault(); self.stopAuto(); self.go(j, true); self.tabs[j].focus(); }
        });
      });
      root.addEventListener("pointerenter", function (e) { if (e.pointerType === "mouse") root.classList.add("is-paused"); });
      root.addEventListener("pointerleave", function () { root.classList.remove("is-paused"); });
      // Auto-advance when the progress bar finishes
      root.addEventListener("animationend", function (e) {
        if (e.animationName === "dkxt-fill" && root.classList.contains("is-auto")) self.go((self.index + 1) % self.tabs.length, false);
      });

      this.vio = ("IntersectionObserver" in window) ? new IntersectionObserver(function (en) {
        self.visible = en[0].isIntersecting;
        if (self.visible) {
          if (self.seconds > 0 && self.tabs.length > 1 && !self.stopped && !dkReduce()) root.classList.add("is-auto");
          self.playActive();
        } else {
          root.classList.remove("is-auto");
          self.pauseAll();
        }
      }, { threshold: 0.35 }) : null;
      if (this.vio) this.vio.observe(root); else { this.visible = true; this.playActive(); }
    }
    Phases.prototype.go = function (i, user) {
      if (i === this.index && !user) return;
      this.index = i;
      this.tabs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle("is-active", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
        t.setAttribute("tabindex", on ? "0" : "-1");
      });
      this.panels.forEach(function (p, k) { var on = k === i; p.classList.toggle("is-active", on); if (on) p.removeAttribute("hidden"); else p.setAttribute("hidden", ""); });
      this.media.forEach(function (m, k) { m.classList.toggle("is-active", k === i); });
      // Restart the progress bar on the new tab
      var bar = this.tabs[i] && this.tabs[i].querySelector(".dkxt-bar");
      if (bar) { bar.style.animation = "none"; void bar.offsetWidth; bar.style.animation = ""; }
      this.playActive();
      // Keep the active tab in view on phones
      var t = this.tabs[i], strip = t && t.parentNode;
      if (strip && strip.scrollWidth > strip.clientWidth) strip.scrollTo({ left: t.offsetLeft - 16, behavior: "smooth" });
    };
    Phases.prototype.stopAuto = function () { this.stopped = true; this.root.classList.remove("is-auto"); };
    Phases.prototype.pauseAll = function () {
      this.media.forEach(function (m) { var v = m.querySelector("video"); if (v && !v.paused) v.pause(); });
    };
    Phases.prototype.playActive = function () {
      var self = this;
      this.media.forEach(function (m, k) {
        var v = m.querySelector("video");
        if (!v) return;
        if (k === self.index && self.visible) dkPlay(v); else if (!v.paused) v.pause();
      });
    };
    Phases.prototype.destroy = function () { if (this.io) this.io.disconnect(); if (this.vio) this.vio.disconnect(); };

    function initAll(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll("[data-dkxt-root]"), function (r) {
        if (!r.__dkx) r.__dkx = new Phases(r);
      });
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { initAll(document); });
    else initAll(document);
    document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
    document.addEventListener("shopify:section:unload", function (e) {
      var r = e.target.querySelector("[data-dkxt-root]");
      if (r && r.__dkx) { if (r.__dkx.destroy) r.__dkx.destroy(); r.__dkx = null; }
    });
    document.addEventListener("shopify:block:select", function (e) {
      var r = e.target.closest && e.target.closest("[data-dkxt-root]");
      if (!r || !r.__dkx) return;
      var i = r.__dkx.tabs.indexOf(e.target);
      if (i > -1) { r.__dkx.stopAuto(); r.__dkx.go(i, true); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
